<template>
	<div class="news-detail-container">
		<button class="back-button" @click="goBack">← {{ $t('返回') }}</button>

		<div class="news-content" v-if="news.title">
			<h1 class="news-title">{{ news.title }}</h1>
			<h2 class="news-subtitle">{{ news.subtitle }}</h2>

			<div class="news-body" v-html="processedContent"></div>
		</div>

		<div v-else class="loading">{{ $t('加载中...') }}</div>
	</div>
</template>

<script>
import { newsApi, baseImgUrl } from '../netTool/api';

export default {
	name: 'newsDetail',
	data() {
		return {
			news: {},
			baseImgUrl: baseImgUrl,
			processedContent: ''
		};
	},
	methods: {
		goBack() {
			this.$router.go(-1);
		},
		processContentImages(content) {
			if (!content) return '';

			const tempDiv = document.createElement('div');
			tempDiv.innerHTML = content;

			const images = tempDiv.getElementsByTagName('img');

			for (let img of images) {
				let src = img.getAttribute('src');
				if (src && !src.startsWith('http') && !src.startsWith('//')) {
					const normalizedBaseUrl = this.baseImgUrl.endsWith('/') ? this.baseImgUrl : this.baseImgUrl + '/';
					const normalizedSrc = src.startsWith('/') ? src.substring(1) : src;

					img.setAttribute('src', normalizedBaseUrl + normalizedSrc);
				}
			}

			return tempDiv.innerHTML;
		},
		async getData() {
			try {
				const response = await newsApi.getNewsById(this.$route.params.id);

				if (response.success && response.news) {
					this.news = {
						...response.news
					};

					this.processedContent = this.processContentImages(this.news.content);
				} else {
					console.error('获取资讯详情失败:', response.message);
				}
			} catch (error) {
				console.error('请求资讯详情出错:', error);
			}
		}
	},
	created() {
		this.getData();
	}
};
</script>

<style scoped>
.news-detail-container {
	max-width: 800px;
	margin: 0 auto;
	padding: 20px;
	font-family: 'Helvetica Neue', Helvetica, 'PingFang SC', 'Hiragino Sans GB', 'Microsoft YaHei', Arial, sans-serif;
}

.back-button {
	background: none;
	border: none;
	font-size: 16px;
	color: #333;
	cursor: pointer;
	margin-bottom: 20px;
	padding: 5px 10px;
	transition: color 0.3s;
}

.back-button:hover {
	color: #1890ff;
}

.news-title {
	font-size: 28px;
	font-weight: 600;
	color: #333;
	margin-bottom: 15px;
	line-height: 1.4;
}

.news-subtitle {
	font-size: 18px;
	color: #666;
	margin-bottom: 30px;
	font-weight: 400;
	line-height: 1.5;
}

.news-body {
	font-size: 16px;
	line-height: 1.8;
	color: #333;
}

.news-body >>> p {
	margin-bottom: 1em;
}

.news-body >>> img {
	max-width: 100%;
	height: auto;
	display: block;
	margin: 20px 0;
}

.loading {
	text-align: center;
	padding: 40px;
	font-size: 16px;
	color: #999;
}
</style>
